import { BrandThemeProvider } from '@montugroup/themes';
import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import AlertSnackbarProvider from '@/components/error/AlertSnackbarProvider';

import {
  OnboardingAlert,
  OnboardingBackground,
  OnboardingBanner,
  OnboardingContent,
  OnboardingFooter,
  OnboardingHeader,
} from '@/components/escript/onboarding/index';

import { LayoutConnector } from '@/context/escript/OnboardingLayout';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { Box } from '@montugroup/design-system';

const LayoutContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export type PortalPartnerLayoutProps = {
  children?: ReactNode;
};

export function OnboardingLayout({ children }: PortalPartnerLayoutProps) {
  const { key: partnerKey } = usePortalPartnerBrand();
  return (
    <LayoutConnector>
      <BrandThemeProvider theme={partnerKey}>
        <AlertSnackbarProvider>
          <LayoutContainer>{children}</LayoutContainer>
        </AlertSnackbarProvider>
      </BrandThemeProvider>
    </LayoutConnector>
  );
}
OnboardingLayout.OnboardingBanner = OnboardingBanner;
OnboardingLayout.OnboardingHeader = OnboardingHeader;
OnboardingLayout.Alert = OnboardingAlert;
OnboardingLayout.Content = OnboardingContent;
OnboardingLayout.Background = OnboardingBackground;
OnboardingLayout.OnboardingFooter = OnboardingFooter;
